import * as React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Button from '@material-ui/core/Button';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import Visibility from '@material-ui/icons/Visibility';
import EditIcon from '@material-ui/icons/Edit';
import Typography from '@material-ui/core/Typography';
import { map, pick } from 'lodash';
import { Link } from 'react-router-dom';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import * as moment from 'moment';
import TablePaginationActions from '../TablePagination';
import Dialog from '../Dialog';

const styles = theme => ({
  cell: {
    border: 'none',
    paddingTop: 20,
    paddingBottom: 20
  },
  roundBtn: {
    height: 40,
    width: 40,
    boxShadow: 'none'
  },
  flexContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  url: {
    wordBreak: 'break-word'
  }
});


class PlacementsTable extends React.Component {
  constructor(props) {
    super(props);
    this.state ={
      page: 0,
      rowsPerPage: 5,
      open: false,
      id:0
    }
  }
  handleChangePage = (event, page) => {
    this.setState({ page });
  };
  handleClickOpen = (id) => {
    this.setState({ open: true, id });
  };

  handleClose = () => {
    this.setState({ open: false });
  };
  render() {
    const { classes, placements, toggleStatus, charities } = this.props;
    const { rowsPerPage, page, open, id } = this.state;
    const uids= Object.keys(placements || {});
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, uids.length - page * rowsPerPage);
    return (
      <div>
        <Table padding="checkbox">
          <TableHead>
            <TableRow>
              <TableCell><Typography variant="title">URL</Typography></TableCell>
              <TableCell><Typography variant="title">CHARITIES</Typography></TableCell>
              <TableCell><Typography variant="title">CREATED DATE</Typography></TableCell>
              <TableCell><Typography variant="title">ACTIONS</Typography></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {placements && map(pick(placements, uids.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)), (placement, id) => {
              const createdAtFormatted = moment(new Date(placement.createdAt)).format('D MMM YYYY, H:mm:ss');
              const placementCharities = placement.charities ? Object.keys( placement.charities) : undefined;
              return (
                <TableRow key={id}>
                  <TableCell className={classes.cell}>
                    <Typography variant="body2" className={classes.url}>
                      {placement.url}
                    </Typography>
                  </TableCell>
                  <TableCell className={classes.cell}>
                    <Typography variant="body1">
                    {placementCharities && placementCharities.map((charId) => {
                      const val = placement.charities[charId]
                      if (val) {
                        const charity = charities[ charId ];
                        if (!charity) {
                          return null;
                        }
                        return <strong key={charId}>{charity.name}</strong>;
                      } else {
                        return null;
                      }
                    })}
                    </Typography>
                  </TableCell>
                  <TableCell className={classes.cell}>
                    <Typography variant="body2">
                      {createdAtFormatted}
                    </Typography>
                  </TableCell>
                  <TableCell className={classes.cell}>
                    <div style={{display: 'flex', justifyContent: 'space-around'}}>
                      <Link to={`placements/edit/${id}`} >
                        <Button variant="fab"  className={classes.roundBtn}>
                          <EditIcon />
                        </Button>
                      </Link>
                      <Button 
                        variant="fab" 
                        color="default" 
                        className={classes.roundBtn} 
                        onClick={() => toggleStatus(id, placement.active)}
                      >
                        {placement.active ? <VisibilityOff /> : <Visibility />}
                      </Button>
                    </div>
                  </TableCell>
                  
                </TableRow>
              );
            })}
            {emptyRows > 0 && (
                <TableRow style={{ height: 90 * emptyRows }}>
                  <TableCell colSpan={6} />
                </TableRow>
              )}
 
          </TableBody>
          <TableFooter>
            <TableRow>
              <TablePagination
                colSpan={12}
                count={uids.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onChangePage={this.handleChangePage}
                ActionsComponent={TablePaginationActions}
                rowsPerPageOptions={[]}
              />
            </TableRow>
          </TableFooter>
        </Table>
        <Dialog 
          open={open} 
          handleClose={this.handleClose} 
          action={() => handleDelete(id)} 
        />
      </div>
    );
  }
}


export default withStyles(styles)(PlacementsTable);
